import { render, staticRenderFns } from "./ReportTransactionsTable.vue?vue&type=template&id=741fbdb5"
import script from "./ReportTransactionsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportTransactionsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports